// import React, { useContext } from "react";
// import { motion } from "framer-motion";
// import displayINRCurrency from "../helpers/displayCurrency";
// import { FaShoppingCart, FaArrowRight } from "react-icons/fa";
// import SummaryApi from "../common";
// import Context from "../context";
// import { useNavigate } from "react-router-dom";

// const VerticalCard = ({ data }) => {

//   const product = data[0];
//   const navigate = useNavigate();
//   const { fetchUserAddToCart } = useContext(Context);

//   // ✅ VARIANT BASED PRICE
//   const variant = product?.variants?.[0];
//   const price = Number(variant?.price || 0);

//   // ✅ ADD TO CART
//   const handleAddToCart = async (e) => {
//     e.stopPropagation(); // 🔥 VERY IMPORTANT

//     const response = await fetch(SummaryApi.addToCartProduct.url, {
//       method: SummaryApi.addToCartProduct.method,
//       credentials: "include",
//       headers: { "content-type": "application/json" },
//       body: JSON.stringify({
//         productId: product?._id,
//         ram: variant?.ram,
//         storage: variant?.storage,
//         price: price
//       }),
//     });

//     const resData = await response.json();

//     if (resData.success) {
//       fetchUserAddToCart();
//       alert("Added to cart ✅");
//     }
//   };

//   // ✅ BUY NOW → GO TO PRODUCT DETAILS
//   const handleBuyNow = (e) => {
//     e.stopPropagation(); // 🔥 IMPORTANT
//     navigate(`/product/${product?._id}`);
//   };

//   return (
//     <motion.div
//       whileHover={{ y: -10 }}
//       onClick={() => navigate(`/product/${product?._id}`)} // 🔥 CARD CLICK
//       className="bg-white rounded-[30px] p-3 shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
//     >

//       {/* IMAGE */}
//       <img
//         src={product?.productImage?.[0]}
//         className="w-full h-64 object-cover rounded-[20px]"
//       />

//       {/* DETAILS */}
//       <div className="mt-4">

//         <h2 className="font-bold text-lg line-clamp-1">
//           {product?.productName}
//         </h2>

//         <p className="text-gray-500 text-sm">
//           {product?.brand}
//         </p>

//         {/* PRICE + BUTTONS */}
//         <div className="flex justify-between items-center mt-4">

//           <div className="bg-gray-100 px-4 py-2 rounded-full font-semibold">
//             {displayINRCurrency(price)}
//           </div>

//           <div className="flex gap-2">

//             {/* ADD TO CART */}
//             <button
//               onClick={handleAddToCart}
//               className="bg-black text-white p-3 rounded-full hover:bg-gray-800"
//             >
//               <FaShoppingCart />
//             </button>

//             {/* BUY NOW */}
//             <button
//               onClick={handleBuyNow}
//               className="bg-black text-white px-4 py-2 rounded-full flex items-center gap-2 hover:bg-gray-800"
//             >
//               Buy <FaArrowRight className="text-xs" />
//             </button>

//           </div>

//         </div>

//       </div>

//     </motion.div>
//   );
// };

// export default VerticalCard;
import React, { useContext, useState } from "react";
import { motion } from "framer-motion";
import displayINRCurrency from "../helpers/displayCurrency";
import { FaShoppingCart, FaHeart, FaStar } from "react-icons/fa";
import SummaryApi from "../common";
import Context from "../context";
import { useNavigate } from "react-router-dom";

const VerticalCard = ({ data }) => {

  const product = data[0]; // same rakha
  const navigate = useNavigate();
  const { fetchUserAddToCart } = useContext(Context);

  const [wish, setWish] = useState(false);
  const [imgIndex, setImgIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const variant = product?.variants?.[0];
  const price = Number(variant?.price || 0);

  // ✅ ADD TO CART
  const handleAddToCart = async (e) => {
    e.stopPropagation();

    if (!product?._id) {
      console.log("Product ID missing ❌");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(SummaryApi.addToCartProduct.url, {
        method: SummaryApi.addToCartProduct.method,
        credentials: "include",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          productId: product._id,
          ram: variant?.ram,
          storage: variant?.storage,
          price: price
        }),
      });

      const data = await res.json();

      if (data.success) {
        fetchUserAddToCart();
      }

    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ BUY NOW FIX
  const handleBuyNow = (e) => {
    e.stopPropagation();
    navigate(`/product/${product?._id}`);
  };

  return (
    <motion.div
      whileHover={{ y: -8 }}
      onClick={() => navigate(`/product/${product?._id}`)}
      className="bg-white rounded-2xl shadow-md overflow-hidden item-center cursor-pointer group hover:shadow-xl transition w-full max-w-[320px]"
    >

      {/* IMAGE */}
      <div
        className="relative bg-gray-100 p-4"
        onMouseEnter={() => setImgIndex(1)}
        onMouseLeave={() => setImgIndex(0)}
      >

        <img
          src={product?.productImage?.[imgIndex] || product?.productImage?.[0]}
          className="h-48 mx-auto object-contain transition duration-300 group-hover:scale-105"
        />

        {/* ❤️ WISHLIST */}
        <button
          onClick={(e) => {
            e.stopPropagation();
            setWish(!wish);
          }}
          className="absolute top-3 right-3 bg-white p-2 rounded-full shadow"
        >
          <FaHeart className={wish ? "text-red-500" : "text-gray-400"} />
        </button>

      </div>

      {/* DETAILS */}
      <div className="p-4">

        {/* TOP */}
        <div className="flex justify-between items-center mb-2">
          <span className="bg-yellow-400 text-xs px-2 py-1 rounded">
            New Arrival
          </span>

          <span className="flex items-center gap-1 text-sm">
            <FaStar className="text-yellow-400" /> 4.5
          </span>
        </div>

        <h2 className="font-semibold text-sm md:text-base line-clamp-1">
          {product?.productName}
        </h2>

        <p className="text-xs text-gray-500 mt-1">
          {product?.brand}
        </p>

        {/* PRICE */}
        <div className="mt-3">
          <p className="font-bold text-lg">
            {displayINRCurrency(price)}
          </p>

          <p className="text-xs text-gray-400 line-through">
            {displayINRCurrency(price + 2000)}
          </p>
        </div>

        {/* BUTTONS */}
        <div className="mt-4 flex gap-2">

          {/* CART */}
          {/* <button
            onClick={handleAddToCart}
            disabled={loading}
            className="flex-1 bg-black text-white py-2 rounded-lg text-xs flex items-center justify-center gap-2 hover:bg-gray-800"
          >
            <FaShoppingCart />
            {loading ? "Adding..." : "Cart"}
          </button> */}

          {/* BUY NOW */}
          <button
            onClick={handleBuyNow}
            className="flex-1 bg-blue-600 text-white py-2 rounded-lg text-xs hover:bg-green-700"
          >
            View Product
          </button>

        </div>

      </div>

    </motion.div>
  );
};

export default VerticalCard;